import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

export default function IconFacebook() {
  return (
    <SvgIcon>
      <path
        d="m24 12c0-6.6281-5.3719-12-12-12s-12 5.3719-12 12c0 6.6281 5.3719 12 12 12 0.07031 0 0.14062 0 0.21094-0.00469v-9.3375h-2.5781v-3.0047h2.5781v-2.2125c0-2.5641 1.5656-3.9609 3.8531-3.9609 1.0969 0 2.0391 0.07969 2.3109 0.11719v2.6812h-1.575c-1.2422 0-1.4859 0.59063-1.4859 1.4578v1.9125h2.9766l-0.38907 3.0047h-2.5875v8.8828c5.0156-1.4391 8.6859-6.0562 8.6859-11.536z"
        style={{ strokeWidth: 0.046875 }}
      />
    </SvgIcon>
  );
}
